import { render } from "./SystemNotifications.vue?vue&type=template&id=ad7570a0&scoped=true"
import script from "./SystemNotifications.vue?vue&type=script&lang=js"
export * from "./SystemNotifications.vue?vue&type=script&lang=js"

import "./SystemNotifications.vue?vue&type=style&index=0&id=ad7570a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad7570a0"]])

export default __exports__